import { Card, CardActionArea, CardHeader } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ToolConfig } from "../../app/backendTypes";
import Avatar from "../common/Avatar";
import { useContract } from "../../app/hooks";

export default function ToolCard(props: { toolConfig: ToolConfig }) {
  const { toolConfig } = props;
  const item = toolConfig.item.tool;

  const { contract } = useContract(item?.contract_id?.toString());

  return (
    <Card>
      <CardActionArea component={RouterLink} to={`/tools/${toolConfig.kind}`}>
        <CardHeader
          title={item?.display_name || contract?.name || toolConfig.kind}
          subheader={item?.short_desc || contract?.short_desc}
          avatar={
            <Avatar
              alt={contract?.name || toolConfig.kind}
              src={item?.avatar || contract?.avatar}
            />
          }
        />
      </CardActionArea>
    </Card>
  );
}
